module.exports = __webpack_public_path__ + "static/img/03.6ebb1ca4.jpg";